<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let text: string;

</script>

<div class="fizz-tooltip-container">
  <button class="fizz-tooltip-trigger fizz-flex-row-8" type="button" on:click|preventDefault>
    <div id="tooltip-target" tabIndex={0}>
      <Icon type="Info" height="16" width="16" color="black" />
    </div>
  </button>
  <div class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center" role="tooltip">
    {text}
  </div>
</div>
